import { render, staticRenderFns } from "./suggestion-picker.vue?vue&type=template&id=c36d8dc2&"
import script from "./suggestion-picker.vue?vue&type=script&lang=js&"
export * from "./suggestion-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports